import { request } from '@blade/common';
/**
*@Description: 导出--Export visitor list
*/
export const getVisitorExport = (data) => request.post('/api/crowd-management/api/v1/cluster/visitor/export', data);
/**
*@Description: Query visitor indicators key
*/
export const getVisitorIndicators = (data) => request.post('/api/crowd-management/api/v1/cluster/visitor/indicators', data);
/**
*@Description: Query visitor List
*/
export const getVisitorPagelist = (data) => request.post('/api/crowd-management/api/v1/cluster/visitor/pagelist', data);
/**
*@Description: Query visitor pie chart
*/
export const getVisitorProportion = (data) => request.post('/api/crowd-management/api/v1/cluster/visitor/proportion', data);
/**
*@Description: Query visitor stay time
*/
export const getVisitorStay = (data) => request.post('/api/crowd-management/api/v1/cluster/visitor/stay', data);
/**
*@Description: Query visitor visitor trends
*/
export const getVisitorTrend = (data) => request.post('/api/crowd-management/api/v1/cluster/visitor/trend', data);
/**
*@Description: tagTree （virtual zone）
*/
export const getVirtualZoneTagTree = (data) => request.post('/api/task-management/api/v1/virtual/zone/tag/tag/tree', data);
/**
*@Description: tagTree （virtual zone）
*/
export const getClusterVisitorType = () => request.get('/api/crowd-management/api/v1/cluster/visitor/type');
